import { useContext } from 'react'

import FullScreenContext from '../../providers/FullScreenProvider.jsx'

const useFullScreen = () => {
    return useContext(FullScreenContext)
}

export default useFullScreen
